
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile-v2/[slug]",
      function () {
        return require("private-next-pages/profile-v2/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile-v2/[slug]"])
      });
    }
  